import React from "react";
import { Box, Divider } from "@mui/material";
import { FORM_MODAL_FOOTER_SX, FORM_MODAL_FOOTER_ACTIONS_SX, FORM_DIVIDER_SX } from "../utils/formModalStyles";

/** Footer divider + action row (mirrors FormModalHeader spacing). */
const FormModalFooter = ({ children, sx = {}, actionsSx = {} }) => (
  <Box sx={{ ...FORM_MODAL_FOOTER_SX, ...sx }}>
    <Divider sx={FORM_DIVIDER_SX} />
    <Box sx={{ ...FORM_MODAL_FOOTER_ACTIONS_SX, ...actionsSx }}>{children}</Box>
  </Box>
);

export default FormModalFooter;
